import { render, staticRenderFns } from "./KnowYourCustomerSubscription.vue?vue&type=template&id=096d903b&scoped=true"
import script from "./KnowYourCustomerSubscription.vue?vue&type=script&lang=js"
export * from "./KnowYourCustomerSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096d903b",
  null
  
)

export default component.exports